/**
 * CX Score subscription tiers. Values are the runtime strings stored on forms and exchanged with the API; the
 * matching display labels live in the {@code CXScoreLanguage} bundle keyed by {@code CX_Score_Licences_<value>}.
 *
 * - {@link CXScoreLicences.CXS_AGENT}: scores recordings (mandatory) and can view the dashboard.
 * - {@link CXScoreLicences.CXS_MANAGER}: can view the dashboard; scoring is toggleable via the device flag.
 *
 * Device-level scoring (monitoring-only, no licence) is controlled by the {@code CXScoreEnabled} device flag.
 */
export enum CXScoreLicences {
    NONE = 'None',
    CXS_AGENT = 'CXSAgent',
    CXS_MANAGER = 'CXSManager'
}

/**
 * Derives the device-level {@code CXScoreEnabled} flag implied by a CX Score licence where it is
 * determinate: {@link CXScoreLicences.CXS_AGENT} always scores ({@code true}) and
 * {@link CXScoreLicences.NONE} never does ({@code false}). For {@link CXScoreLicences.CXS_MANAGER}
 * scoring is a separate user choice, so {@code undefined} is returned and callers should omit the
 * flag rather than overwrite the current device state.
 *
 * @param licence The CX Score licence selected for the user, when known.
 * @returns The implied flag value, or {@code undefined} when the licence does not determine it.
 */
export function deriveCxsScoreEnabledForLicence(licence: Definable<CXScoreLicences>): Definable<boolean> {
    if (licence === CXScoreLicences.CXS_AGENT) return true

    if (licence === CXScoreLicences.NONE) return false

    return undefined
}
